import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generatePartialBreakdownPdf } from "../../Others/Pdf/generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PartialBreakdownPdf = ({
  schedule,
  company,
  grossBalance,
  adjustedTotalBalance,
  lines,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    grossBalance,
    adjustedTotalBalance,
    lines,
    notes,
    reviewNotes,
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generatePartialBreakdownPdf(forView, ...sharedArgs)
        }
        downloadName='Partial Breakdown'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generatePartialBreakdownPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PartialBreakdownPdf;
